<vip-views-modal-error
  (confirm)="confirmCheck()"
  (support)="onSupportCheck()"
></vip-views-modal-error>
